import React, { useCallback, useContext, useReducer } from 'react';

import { NOOP } from '~/NOOP';

import { reducer } from './reducer';
import { ISidePanelContext } from './types';

export const MAX_ATTACHMENTS = 10;

const defaultContext: ISidePanelContext = {
  tab: 'tab-config',
  view: 'list-issues',
  modified: [],
  dispatch: NOOP,
  attach: NOOP,
};

const SidePanelContext = React.createContext<ISidePanelContext>(defaultContext);

interface ISidePanelProvider {
  children: React.ReactNode;
}

export const SidePanelProvider: React.FC<ISidePanelProvider> = (props) => {
  const [context, dispatch] = useReducer(reducer, defaultContext);
  const { attachTo } = context;

  const attach = useCallback((...blobs: Blob[]) => {
    const images = blobs.map((blob) => {
      const src = URL.createObjectURL(blob);
      return { src, blob };
    });

    if (attachTo) {
      dispatch({
        action: 'attach',
        next: {
          attachTo: {
            images,
          },
        },
      });
    }
  }, [attachTo, dispatch]);

  context.dispatch = useCallback((action, next) => {
    dispatch({ action, next });
  }, []);

  context.attach = attach;

  return (
    <SidePanelContext.Provider value={context}>
      {props.children}
    </SidePanelContext.Provider>
  );
}

export const useSidePanel = () => useContext(SidePanelContext);

